<template>
  <div>
    <div>
      <div class="columns">
        <div class="column is-12">
          <div class="field">
            <label class="label">Email Address<b-icon pack="fas" icon="star" class="fa-ss"></b-icon><a class="is-pulled-right" @click="onRemoveEmailConfirm"><i class="has-text-danger fas fa-trash fa-sm"></i></a></label>
            <div class="field is-grouped is-align-items-flex-end">
              <div class="control is-expanded">
                <div class="control has-icons-left has-icons-right">
                  <input :name="instanceName + '.email'" :data-vv-scope="scope" data-vv-as="email address" v-validate="{'required': isRequired, 'email': true, 'email_unique': isUniqueEmail}" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has(validationName + 'email') }" type="text" placeholder="Email" v-model="customerEmail.email" data-lpignore="true" autocomplete="off">
                  <span v-show="errors.has(validationName + 'email')" class="help is-danger">
                    <i v-show="errors.has(validationName + 'email')" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName + 'email') }}
                  </span>
                  <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                  </span>
                  <span class="icon is-small is-right" v-show="!errors.has(validationName + 'email')">
                    <i class="fas fa-check"></i>
                  </span>
                  <span class="icon is-small is-right" v-show="errors.has(validationName + 'email')">
                    <i class="fas fa-exclamation-triangle"></i>
                  </span>
                </div>
              </div>
              <div class="control">
                <b-checkbox
                  :native-value="false"
                  name="chkWrongProfile"
                  type="is-info"
                  v-tooltip="'Is Wrong Profile'"
                  v-model="customerEmail.isWrongProfile">
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-loading :is-full-page="true" :active.sync="showLoader" :canCancel="false"></b-loading>
    </div>
    <confirm-delete-modal v-if="isDeleteConfirmationActive" title="Confirm Delete Email" @on-confirm-delete="onRemoveEmail" @on-cancel-delete="isDeleteConfirmationActive = false">
      Are you sure you wish to delete the selected email?
    </confirm-delete-modal>
  </div>
</template>

<script>
import ConfirmDeleteModalComponent from '@/components/generic/ConfirmDeleteModalComponent'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'EmailCapture',
  props: {
    value: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    scope: {
      type: String,
      default: null
    },
    getValidationErrors: {
      type: Boolean,
      default: false
    },
    useValidator: {
      type: Object,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isUniqueEmail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'confirm-delete-modal': ConfirmDeleteModalComponent
  },
  data () {
    return {
      instanceName: this.$uuid.v4(),
      showLoader: false,
      customerEmail: this.value,
      isDeleteConfirmationActive: false
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    validationName: function () {
      return (this.scope) ? this.scope + '.' + this.instanceName + '.' : this.instanceName + '.'
    }
  },
  methods: {
    onRemoveEmailConfirm: function () {
      this.isDeleteConfirmationActive = true
    },
    onRemoveEmail: function () {
      this.$emit('on-email-remove', this.customerEmail)
    }
  },
  watch: {
    'value.key': function (newValue, oldValue) {
      this.$forceUpdate()
    },
    getValidationErrors: function (newValue, oldValue) {
      if (newValue === true) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.customerEmail.hasValidationErrors = false
            this.customerEmail.canSave = true
          } else {
            this.customerEmail.hasValidationErrors = true
            this.customerEmail.canSave = false
          }
        })
      }
    }
  },
  created: function () {
    if (this.useValidator) {
      this.$validator = this.useValidator
    } else {
      this.$validator = this.$parent.$validator
    }
  }
}
</script>

<style scoped>
</style>
